import { ThemePicker } from "./theme-picker.js";

interface BrandProps {
  onReset(): void;
}

export function Brand({ onReset }: BrandProps) {
  return (
    <header class="topbar">
      <button class="brand" id="brand" type="button" aria-label="Start over" onClick={onReset}>
        <span class="brand-mark" aria-hidden="true">
          <svg viewBox="0 0 40 32" focusable="false">
            <path class="cow-ear cow-ear-old" d="M12 9C8 6 3 7 3 11c3 3 7 3 10 0Z" />
            <path class="cow-ear cow-ear-new" d="M28 9c4-3 9-2 9 2-3 3-7 3-10 0Z" />
            <path class="cow-diff cow-diff-old" d="M6.5 10.5h4" />
            <path class="cow-diff cow-diff-new" d="M29.5 10.5h4m-2-2v4" />
            <path class="cow-head" d="M20 3c-7 0-10 4-10 11v5c0 7 4 11 10 11s10-4 10-11v-5C30 7 27 3 20 3Z" />
            <path class="cow-spot" d="M17 3.5c4-1 8 0 10 2.5 2 3 0 6-3 7-4 1-7-2-7-6 0-1 0-2 0-3.5Z" />
            <circle class="cow-eye" cx="14.5" cy="15" r="1.35" />
            <circle class="cow-eye" cx="25.5" cy="15" r="1.35" />
            <circle class="cow-eye-shine" cx="14.9" cy="14.6" r=".4" />
            <circle class="cow-eye-shine" cx="25.9" cy="14.6" r=".4" />
            <path class="cow-muzzle" d="M13 21c1-3 3-4 7-4s6 1 7 4v2c0 4-3 6-7 6s-7-2-7-6Z" />
            <circle class="cow-nostril" cx="17" cy="21" r=".9" />
            <circle class="cow-nostril" cx="23" cy="21" r=".9" />
            <path class="cow-smile" d="M18 24c1 1 3 1 4 0" />
          </svg>
        </span>
        <span>cowdiff</span>
      </button>
      <ThemePicker />
    </header>
  );
}
